import { create } from 'zustand';
import type { AuthProfile } from '@payroll/shared';

interface AuthState {
  jwt: string | null;
  profile: AuthProfile | null;
  setAuth: (jwt: string, profile: AuthProfile) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  jwt: null,
  profile: null,
  setAuth: (jwt, profile) => set({ jwt, profile }),
  clear: () => set({ jwt: null, profile: null }),
}));
